<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import TopNavAccountMenu from '@/components/top_nav/TopNavAccountMenu.vue';
import TopNavNotificationsButton from '@/components/top_nav/TopNavNotificationsButton.vue';

import type { TopNavUser } from '@/components/top_nav/types';

const { user, unreadSupportMessageCount = 0 } = defineProps<{
  user: TopNavUser;
  unreadSupportMessageCount?: number;
}>();

const emit = defineEmits<{
  openSupportChat: [];
}>();

const { t } = useI18n();

const HELP_CENTER_URL =
  'https://community.loadsmart.com/hc/en-us/sections/24987137080851-New-Warehouse-Portal-Opendock-Nova';
</script>

<template>
  <v-app-bar
    flat
    border="b"
    :order="1"
    class="bg--color-neutral-0 border--color-line-border px-4"
    data-testid="top-nav">
    <template #append>
      <div class="d-flex align-center ga-2">
        <v-tooltip location="bottom" :text="t('navigation.sidebarLinks.supportChat')">
          <template #activator="{ props: supportChatTooltipProps }">
            <v-btn
              v-bind="supportChatTooltipProps"
              icon
              variant="text"
              :aria-label="t('navigation.sidebarLinks.supportChat')"
              data-testid="top-nav-support-chat"
              @click="emit('openSupportChat')">
              <v-badge
                :model-value="unreadSupportMessageCount > 0"
                :content="unreadSupportMessageCount"
                color="error"
                data-testid="top-nav-support-chat-badge">
                <v-icon>mdi-message</v-icon>
              </v-badge>
            </v-btn>
          </template>
        </v-tooltip>

        <v-tooltip location="bottom" :text="t('navigation.sidebarLinks.help')">
          <template #activator="{ props: helpTooltipProps }">
            <v-btn
              v-bind="helpTooltipProps"
              icon="mdi-lifebuoy"
              variant="text"
              :href="HELP_CENTER_URL"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="t('navigation.sidebarLinks.help')"
              data-testid="top-nav-help" />
          </template>
        </v-tooltip>

        <top-nav-notifications-button />

        <top-nav-account-menu :user="user" />
      </div>
    </template>
  </v-app-bar>
</template>
